export default __webpack_public_path__ + "static/media/plumber-on-kitchen.3671f9b9.webp";